export const DISPLAY_NEW_REFERRAL_INTRO_DIALOG =
  'DISPLAY_NEW_REFERRAL_INTRO_DIALOG';
